import * as React from 'react';

import { RecommendationsList } from '../../components/RecommendationsList';
import { RecommendationsListDesktop } from '../../components/RecommendationsListDesktop';
import { useRecommendations } from './useRecommendations';
import { ELoadingStatus } from '../../types/loadingStatus';
import { Recommendation, RecommendationSkeleton } from '../../components/Recommendation';
import { TRecommendation } from '../../types/recommendation';
import { RecommendationDesktop, RecommendationDesktopSkeleton } from '../../components/RecommendationDesktop';

export function RecommendationsListContainer() {
  const {
    recommendations,
    onRecommendationClick,
    onShow,
    onShowTrap,
    showHeader,
    recommendationsStatus,
    isMobile,
    regionId,
  } = useRecommendations();

  const recommendationsMobileSkeleton = React.useMemo(
    () =>
      new Array(18)
        .fill(0)
        .map((_, index) => <RecommendationSkeleton key={`recommendation-mobile-skeleton-${index}`} />),
    [],
  );

  const recommendationsDesktopSkeleton = React.useMemo(
    () =>
      new Array(8)
        .fill(0)
        .map((_, index) => <RecommendationDesktopSkeleton key={`recommendation-desktop-skeleton-${index}`} />),
    [],
  );

  if (!recommendations.length && recommendationsStatus === ELoadingStatus.Loading) {
    return isMobile ? (
      <RecommendationsList withHeader={showHeader}>{recommendationsMobileSkeleton}</RecommendationsList>
    ) : (
      <RecommendationsListDesktop>{recommendationsDesktopSkeleton}</RecommendationsListDesktop>
    );
  }

  return isMobile ? (
    <RecommendationsList onShow={onShow} withHeader={showHeader}>
      {recommendations.map((recommendation, index) => (
        <Recommendation
          onClick={onRecommendationClick}
          onShowTrap={onShowTrap}
          key={`recommendation-${index}`}
          {...recommendation}
        />
      ))}
    </RecommendationsList>
  ) : (
    <RecommendationsListDesktop onShow={onShow}>
      {recommendations.map((recommendation: TRecommendation) => (
        <RecommendationDesktop
          onClick={onRecommendationClick}
          onShowTrap={onShowTrap}
          regionId={regionId}
          key={recommendation.offerId}
          {...recommendation}
        />
      ))}
    </RecommendationsListDesktop>
  );
}
